import { Component, Inject, LOCALE_ID, OnInit } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { Userprofile } from "src/app/_models/Userprofile";
import { GetOwnUserProfile } from "src/app/_store/user-profile/user-profile.actions";
import { selectOwnUserProfile } from "src/app/_store/user-profile/user-profile.selectors";
import { AppConstants } from "src/app/constants/constants";
import { Roles } from "src/app/constants/Roles";

@Component({
  selector: "app-information-tutor-resources",
  templateUrl: "./information-tutor-resources.component.html",
  styleUrls: ["./information-tutor-resources.component.scss"],
})
export class InformationTutorResourcesComponent implements OnInit {
  isLoggedIn: boolean;
  userProfile$: Observable<Userprofile>;
  learnerRole: number = Roles.Learner;
  siteLanguageCode: string = this.localeId;
  welshLangCode: string = AppConstants.WELSH_LANG_CODE;
  constructor(
    @Inject(LOCALE_ID) protected localeId: string,
    private authService: MsalService,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.isLoggedIn = this.hasLoggedInUser();
    if(this.isLoggedIn) {
      this.dispatchGetOwnUserProfile();
      this.selectOwnUserProfile();
    }
  }

  hasLoggedInUser(): boolean {
    return this.authService.instance.getAllAccounts().length > 0;
  }

  dispatchGetOwnUserProfile(): void {
    this.store.dispatch(GetOwnUserProfile());
  }

  selectOwnUserProfile(): void {
    this.userProfile$ = this.store.select(selectOwnUserProfile);
  }
}
